import service from "@irati/utils/tracking/index";
var tracking = {};
tracking.viewGetStarted = function () {
    service.trackMedicalEvent("medical_view_get_started");
};
tracking.viewStep = function (step, activationCode) {
    if (activationCode === void 0) { activationCode = null; }
    service.trackMedicalEvent("medical_view_step", { step: step, activationCode: activationCode });
};
tracking.detailsSubmitted = function (activationCode) {
    service.trackMedicalEvent("medical_details_submitted", { activationCode: activationCode });
};
tracking.textRequested = function (activationCode, page) {
    service.trackMedicalEvent("medical_text_requested", { activationCode: activationCode, page: page });
};
tracking.viewHome = function (activationCode) {
    service.trackMedicalEvent("medical_view_home", { activationCode: activationCode });
};
tracking.viewMoreInfo = function (activationCode, name) {
    service.trackMedicalEvent("medical_view_more_info", { activationCode: activationCode, name: name });
};
tracking.downloadPolicy = function (activationCode, name) {
    service.trackMedicalEvent("medical_download_policy", { activationCode: activationCode, name: name });
};
tracking.downloadCertificate = function (activationCode) {
    service.trackMedicalEvent("medical_download_certificate", { activationCode: activationCode });
};
tracking.makeClaim = function (activationCode) {
    service.trackMedicalEvent("medical_make_claim", { activationCode: activationCode });
};
tracking.viewVideo = function (tier) {
    service.trackMedicalEvent("medical_view_video", { tier: tier });
};
tracking.viewReports = function () {
    service.trackMedicalEvent("medical_view_reports");
};
tracking.downloadReport = function (trackingEventName) {
    service.trackMedicalEvent(trackingEventName);
};
tracking.continueOnline = function (activationCode, page) {
    service.trackMedicalEvent("medical_continue_web", { activationCode: activationCode, page: page });
};
tracking.viewStepApp = function (step) {
    service.trackMedicalEvent("medical_view_step_app", { step: step });
};
tracking.launchApp = function (activationCode, page) {
    service.trackMedicalEvent("medical_launch_app", { activationCode: activationCode, page: page });
};
export default tracking;
